// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as _ from 'lodash'
import moment from 'moment'

import {PatientActions}  from '../reducers/patient/index'
import { getDiagnosisRemarksCombinedAnswer } from '../examLogic/diagnosisRemarks';
import { getVisibleExamItems } from '../examLogic/disabilityExtremityVisibility';
import {
    Button,
    Col,
    Row
} from '@sketchpixy/rubix'
import LoadingDocument from "../components/FileWritingGif";
import NotificationSystem from 'react-notification-system';
import {FIELD_STATUSES} from '../utils'

import back_ssn  from "../ssn/back";
import neck_ssn  from "../ssn/neck";
import ankle_ssn  from "../ssn/ankle";
import wrist_ssn  from "../ssn/wrist";
import knee_ssn  from "../ssn/knee";
import shoulder_ssn  from "../ssn/shoulder";

import hip_ssn  from "../ssn/hip";
import elbow_ssn  from "../ssn/elbow";
import mental_ssn  from "../ssn/mental";
import ptsd_ssn  from "../ssn/ptsd";
import kidney_ssn  from "../ssn/kidney";
import ibs_ssn  from "../ssn/ibs";
import sinusitis_ssn  from "../ssn/sinusitis";
import veins_ssn  from "../ssn/veins";
import tmj_ssn  from "../ssn/tmj";
import sleep_ssn  from "../ssn/sleep";
import headache_ssn  from "../ssn/headache";
import heart_ssn  from "../ssn/heart";
import nerves_ssn  from "../ssn/nerves";
import hepatitis_ssn  from "../ssn/hepatitis";
import prostateCancer_ssn  from "../ssn/prostateCancer";
import seizure_ssn  from "../ssn/seizure";
import skin_ssn  from "../ssn/skin";
import foot_ssn  from "../ssn/foot";
import asthma_ssn  from "../ssn/asthma";
import handFingers_ssn  from "../ssn/handFingers";
import bladder_ssn  from "../ssn/bladder";
import fibromyalgia_ssn  from "../ssn/fibromyalgia";
import arthritis_ssn  from "../ssn/arthritis";
import gerd_ssn  from "../ssn/gerd";
import hemorrhoids_ssn from '../ssn/hemorrhoids';
import diabeticNeuro_ssn from '../ssn/diabeticNeuro';
import diabetes_ssn from '../ssn/diabetes';
import ed_ssn from '../ssn/erectileDysfunction';
import scars_ssn from '../ssn/scars';
// import test_ssn  from "../ssn/test";


class Review extends Component {
    constructor(props) {
        super(props)
        console.log("PROPS REVIEW: ", props)
        sessionStorage.removeItem("current")
        let ssn_question = ''
        
        let currentDbq = this.props.location && this.props.location.currentDbq ? this.props.location.currentDbq : JSON.parse(sessionStorage.getItem('currentDbq'));
        let dbq = currentDbq && currentDbq.name ? currentDbq.name : "";

        let patient = this.props.location && this.props.location.patient ? this.props.location.patient: JSON.parse(sessionStorage.getItem("patient"));
        let questionState = this.props.location && this.props.location.questionState ? this.props.location.questionState : JSON.parse(sessionStorage.getItem("questionState"));
        
        let page = this.props.location && this.props.location.page ? this.props.location.page : sessionStorage.getItem("page")

        let diagnosesAndExtremities = JSON.parse(sessionStorage.getItem('currentDiagnosesAndExtremities'))
        
        // if (dbq.toLowerCase() === 'back disabilities') {
        //     ssn_question = back_ssn;
        // } else if (dbq.toLowerCase() === 'neck disabilities') {
        //     ssn_question = neck_ssn
        // } else if (dbq.toLowerCase() === 'ankle disabilities') {
        //     ssn_question = ankle_ssn
        // } else if (dbq.toLowerCase() === 'wrist conditions') {
        //     ssn_question = wrist_ssn
        // } else if (dbq.toLowerCase() === 'knee disabilities') {
        //     ssn_question = knee_ssn;
        // } else if (dbq.toLowerCase() === 'shoulder disabilities') {
        //     ssn_question = shoulder_ssn;
        // } else if (dbq.toLowerCase() === 'hip disabilities') {
        //     ssn_question = hip_ssn
        // } else if (dbq.toLowerCase() === 'elbow disabilities') {
        //     ssn_question = elbow_ssn;
        // } else if (dbq.toLowerCase() === 'mental disorders other than ptsd') {
        //      ssn_question = mental_ssn;
        // } else if (dbq.toLowerCase() === 'ptsd') {
        //     ssn_question = ptsd_ssn;
        // } else if (dbq.toLowerCase() === 'kidney disease, kidney stones, etc') {
        //     ssn_question = kidney_ssn;
        // } else if (dbq.toLowerCase() === 'ibs') {
        //     ssn_question = ibs_ssn;
        // } else if (dbq.toLowerCase() === 'sinusitis') {
        //     ssn_question = sinusitis_ssn;
        // } else if (dbq.toLowerCase() === 'nerve disabilities') {
        //     ssn_question = nerves_ssn;
        // } else if (dbq.toLowerCase() === 'heart disabilities') {
        //     ssn_question = heart_ssn;
        // } else if (dbq.toLowerCase() === 'tmj') {
        //     ssn_question = tmj_ssn;
        // } else if (dbq.toLowerCase() === 'sleep apnea') {
        //     ssn_question = sleep_ssn;
        // } else if (dbq.toLowerCase() === 'varicose veins, peripheral vascular disease, etc.') {
        //     ssn_question = veins_ssn;
        // } else if (dbq.toLowerCase() === 'migraines, tension headaches, etc.') {
        //     ssn_question = headache_ssn;
        // } else if (dbq.toLowerCase() === 'hepatitis') {
        //     ssn_question = hepatitis_ssn;
        // } else if (dbq.toLowerCase() === 'prostate cancer') {
        //     ssn_question = prostateCancer_ssn;
        // } else if (dbq.toLowerCase() === 'seizure disorders') {
        //     ssn_question = seizure_ssn;
        // } else if (dbq.toLowerCase() === 'skin diseases') {
        //     ssn_question = skin_ssn;
        // } else if (dbq.toLowerCase() === 'pes planus or plantar fasciitis') {
        //     ssn_question = foot_ssn;
        // } else if (dbq.toLowerCase() === 'asthma, sarcoidosis, etc.') {
        //     ssn_question = asthma_ssn;
        // } else if (dbq.toLowerCase() === 'hand and fingers') {
        //     ssn_question = handFingers_ssn;
        // } else if (dbq.toLowerCase() === 'bladder disabilities, urinary tract infection, etc.') {
        //     ssn_question = bladder_ssn;
        // } else if (dbq.toLowerCase() === 'fibromyalgia') {
        //     ssn_question = fibromyalgia_ssn;
        // } else if (dbq.toLowerCase() === 'gout') {
        //     ssn_question = arthritis_ssn;
        // } else if (dbq.toLowerCase() === 'gerd, hiatal hernia, etc.') {
        //     ssn_question = gerd_ssn;
        // } else if (dbq.toLowerCase() === 'hemorrhoids') {
        //     ssn_question = hemorrhoids_ssn;
        // } else if (dbq.toLowerCase() === 'diabetic neuropathy') {
        //     ssn_question = diabeticNeuro_ssn;
        // } else if (dbq.toLowerCase() === 'diabetes') {
        //     ssn_question = diabetes_ssn;
        // } else if (dbq.toLowerCase() === 'erectile dysfunction, prostatitis, etc.') {
        //     ssn_question = ed_ssn;
        // } else if (dbq.toLowerCase() === 'scars') {
        //     ssn_question = scars_ssn;
        // } 
        

        if (patient && patient.ssn && patient.ssn.docName.value && patient.ssn.docNpi.value) {
            ssn_question = patient.ssn
        } else {
            ssn_question = patient.ssn
            let ssn = patient && patient.ssn_encrypt_c;
            if (ssn_question && ssn_question.ssn) {
                ssn_question.ssn.value = ssn ? ssn : '';
            }
            let doctorInfo = patient.doctorsInfo        
            ssn_question.ssn.value = ssn ? ssn : '';
            ssn_question.docName ? ssn_question.docName.value = doctorInfo && doctorInfo.name ? doctorInfo.name : '' : '';
            ssn_question.docArea ? ssn_question.docArea.value = doctorInfo && doctorInfo.area ? doctorInfo.area : '' : '';
            ssn_question.docNpi ? ssn_question.docNpi.value = doctorInfo && doctorInfo.npi ? doctorInfo.npi : '' : '';
            ssn_question.docPhone ? ssn_question.docPhone.value = doctorInfo && doctorInfo.phone ? doctorInfo.phone : '' : '';
            ssn_question.docLicenseNo ? ssn_question.docLicenseNo.value = doctorInfo && doctorInfo.licenseNo ? doctorInfo.licenseNo : '' : '';
            ssn_question.docAddress ? ssn_question.docAddress.value = doctorInfo && doctorInfo.address ? doctorInfo.address : '' : '';
            patient.ssn = ssn_question
        }
        
        this.state = {
          patient: patient,
          currentDbq: currentDbq,
          questions: questionState,
          current: 0,
          selectedLicense: sessionStorage.getItem("selectedLicense")
            ? sessionStorage.getItem("selectedLicense")
            : "",
            diagnosesAndExtremities: diagnosesAndExtremities
        };
    }

    actions = link => {
        // const { location } = this.props
        const { patient, questions, currentDbq, ssn, diagnosesAndExtremities } = this.state
        //const updatedQuestions = [];
        // below code is commented because we don't want to filter show=false questions
        // if(questions){
        //     for(let i =0; i < questions.length; i++){
        //         updatedQuestions.push(questions[i])
        //         if(questions[i].type === "yesno" && questions[i].answer !== questions[i].presidence) {
        //             i = i + questions[i].ref;
        //         }
        //     } 
        // }
        this.props.updatePatientDoc(patient.id, patient.apptDate, currentDbq.name, questions, patient.ssn, 'review', patient.name, currentDbq.id, patient.isPreviousVersion, patient.apptId, this.state.selectedLicense, diagnosesAndExtremities, moment().format('MM-DD-YYYY'))
    }

    goBack = (link, current) => {
        const { history, location } = this.props
        const { patient, questions, currentDbq, ssn } = this.state
        sessionStorage.setItem("patient", JSON.stringify(patient))
        sessionStorage.setItem('currentDbq', JSON.stringify(currentDbq))
        let src = sessionStorage.getItem('src') ? sessionStorage.getItem('src') : ""
        if (current === 0 && src === "signLater") {
            link = "/admin/signLater"
        }
        history.push({ pathname: link, current: current, currentDbq: this.state.currentDbq, patient: this.state.patient, questionState: this.state.questions, page:"review" })
    }

    componentWillReceiveProps(newProps) {
        let {patientInfo, fetching, isPatientUpdate, error} = newProps

        console.log("newProps ", newProps)
        sessionStorage.removeItem("fileUrl")
        const { history, location } = this.props

        if (!fetching) {
            history.push({pathname:'/admin/dbq', file: patientInfo, currentDbq: this.state.currentDbq, patient: this.state.patient, questionState: this.state.questions})
        } else {
            console.log("error", error)
            if(error) {
                this._addNotification(error, 'error', 'Error Message: ');
            }          
        }
    }

    getSection = (section) => {
        // return <div className="row col-sm-12">
        //             <div className="col-sm-2 review-sub-heading">Page:  <span className="review-heading">{section ? section.page: ""}</span></div>
        //             <div className="col-sm-7 review-sub-heading">{section ? section.title: ""}</div>
        //             {section.number && <div className="col-sm-3 review-sub-heading">Section:  <span className="review-heading">{section.number}</span></div>}
        //         </div>

        return <table style={{width: "100%", fontSize: 18, color: '#022144'}}>
                <tr>
                    <td style= {{width: '90%'}}><span>DBQ Section : <b>{section.number} - {section.title}</b></span></td>
                    <td style={{width: '10%'}}><span><b>Page: {section.page}</b></span></td>
                </tr>
                </table>
    }

    getElement= (question, current, patient) => {
        let divContainer = '';
        const visibleQuestionItems = getVisibleExamItems(question.questions);
        if (question.type === "text") {
            divContainer = <div key={"textfieldDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                <div className="col-md-10 review__normal p-0" >
                Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question) }</span>
                    {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>
                </div>
                    <span className="review__normal">
                            Answer:
                    </span>
                <ul>
                { question.questions.map((optn, index) => 
                            optn.answer &&
                        <div  key={"textfieldDivResult"+index} className="row col-md-12">
                            <li><div className="col-md-6">
                                <label className="review__bold">{optn.main}</label> 
                            </div>
                            <div className="col-md-4 p-0"> 
                                <label className="review__bold" style={{wordBreak: "break-word"}}>{optn.answer}</label>
                            </div></li>
                        </div>
                    )}
                </ul>
            </div>
        }

        if (question.type === "select") {
            divContainer = <div key={"selectfieldDivFirstResult"+current} className="row review-box" >
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >
                        Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>                    
                </div>
                <span className="review__normal">
                            Answer:
                    </span>
                <ul>
                { question.questions.map((selectbutton, index) => 
                            selectbutton.options.map((optn, index) => 
                            optn.answer &&
                        <div  key={"selectfieldDivResult"+index} className="row col-md-12">
                            <li><div className="col-md-6">
                                <label className="review__normal">{optn.main}</label> 
                            </div>
                            <div className="col-md-4 p-0"> 
                                <label className="review__bold" style={{wordBreak: "break-word"}} >{optn.answer}</label>
                            </div></li>
                        </div>
                    ))}
                </ul>
            </div>
        }

        if (question.type === "calendar") {
            divContainer = <div key={"selectfieldDivFirstResult"+current} className="row review-box" >
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review-heading p-0" >{this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>                    
                </div>
               { question.questions.map((selectbutton, index) => 
                        selectbutton.options.map((optn, index) => 
                        optn.answer &&
                    <div  key={"selectfieldDivResult"+index} className="row col-md-12 mb-20">
                        <div className="col-md-6">
                            <label className="review__bold">{optn.main}</label> 
                        </div>
                        <div className="col-md-4 p-0"> 
                            <label className="review__bold" style={{wordBreak: "break-word"}} >{optn.answer}</label>
                        </div>
                    </div>
                ))}
                
            </div>
        }

        if (question.type === "radio") {
            divContainer = <div key={"selectfieldDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12">
                    <div className="col-md-10 review__normal p-0">
                        Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span> {this.getRedHeading(question)}</span>
                        {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>                    

                </div>
                <span className="review__normal">Answer:</span>
                <ul>
                { 
                visibleQuestionItems.map((ques, index) =>
                    <div key={index} className="row col-md-12">
                        <li>{
                            ques && ques.label && !ques.radioGroup && <div className="col-md-6 review__bold">{ques.label}</div>
                        }
                        
                        {/* <div className="col-md-9" key={"selectfieldDivResult"+index}> 
                            {/* {
                                ques.options.map((optn, i) =>                         
                                <div key={i}  className=" mb-20">
                                    <label key={optn.main+i} className="review__bold">{optn.main}</label>
                                </div>
                            )} 
                            { */}
                                {ques.answer && <div className="review__bold">
                                <label >{ques.answer}</label>
                                </div>}
                        </li>        
                    </div>)
                }
                </ul>
            </div>
        }

        if (question.type === "radioTiles") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>
                </div>

                {/* {question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div   className=" mb-20">
                            <label className="review__bold">{ques.main}</label>
                        </div>
                        }
                    </div>)
                } */}
                <span className="review__normal">
                            Answer:
                    </span>
                <ul>
                    {question.questions.map((ques, index) =>
                        
                        <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                            {  question.multi && ques.answer ?                    
                            <div>
                                <li><label className="review__bold">{ques.main} {ques.redMain && ques.redMain}</label></li>
                                {ques.textarea && <ul><li><span className='review__normal'>{question.textAnswer || ques.textAnswer}</span></li></ul>}
                            </div>
                            :
                            question.answer === ques.dbqName && <div>
                                <li><label className="review__bold">{ques.main} {ques.redMain && ques.redMain}</label></li>
                                {ques.textarea && <span className='review__normal'>{question.textAnswer || ques.textAnswer}</span>}
                            </div>
                            }
                        </div>)
                    }
                </ul>
                
            </div>
        }
        if (question.type === "scarsLoad") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    {!question.refId && <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>}
                </div>

                {/* {question.questions.options.map((opt, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div   className=" mb-20">
                            <label className="review__bold">{opt.main}</label>
                        </div>
                        }
                    </div>)
                } */}
                <span className="review__normal">Answer:</span>
                <div className="row col-md-12" key={"selectfieldDivResult"}> 
                    <div>
                        <label className="review__bold">{question.questions.answer}</label>
                        <label className="review__bold">Location: {question.questions.text1}</label>
                    </div>                        
                </div>

                <ul>
                {question.questions.answer === "Affected" && question.questions.scars.map((scar, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <li><div>
                            <label className="review__bold">{`Scar # ${scar.main} (${scar.answerLength} x ${scar.answerWidth}) cm`}</label>
                        </div></li>
                        }
                    </div>)
                }</ul>
            </div>
        }
        if (question.type === "scarQuestions") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    {!question.refId && <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>}
                </div>
                <span className="review__normal">Answer:</span>
                {question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div>
                            <ul><label className="review__normal">{ques.main}</label>
                            {ques.scars.map((scar, i) =>
                    
                                <div className="row col-md-12" key={"selectfieldDivResult"+index+i} style={{marginLeft: 10}}> 
                                    {  scar.answer === "X" && <li><div>
                                        <label className="review__bold">Scar # {i+1}</label>
                                    </div></li>
                                    }
                                </div>)
                            }
                        </ul></div>
                        }
                    </div>)
                }
                
            </div>
        }

        if (question.type === "disfigurementLoad") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    {!question.refId && <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>}
                </div>
                <span className="review__normal">Answer:</span>               
                {question.questions.scars.map((scar, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index} style={{marginLeft: 0, paddingTop: 20}}> 
                        <div className="row col-md-12" key={"selectfieldDivResultScar"+index}>                     
                            <div>
                                <label className="review__bold">{scar.answer}{` # ${scar.main} (${scar.answerLength} x ${scar.answerWidth}) cm`}</label>
                            </div>
                        </div>
                        <div className="row col-md-12" key={"selectfieldDivResultAnswer"}> 
                            <div>
                                <label className="review__bold">Location: {scar.text1}</label>
                            </div>                        
                        </div> 
                    </div>
                    )
                }
            </div>
        }
        if (question.type === "disfigureQuestions") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    {!question.refId && <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>}
                </div>
                <span className="review__normal">Answer:</span>
                {question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div>
                            <ul><label className="review__bold">{ques.main}</label>
                            {ques.scars.map((scar, i) =>
                    
                                <div className="row col-md-12" key={"selectfieldDivResult"+index+i} style={{marginLeft: 10}}> 
                                    {  scar.answer === "X" && <li><div>
                                        <label className="review__bold">Scar # {i+1}</label>
                                    </div></li>
                                    }
                                </div>)
                            }
                        </ul></div>
                        }
                    </div>)
                }
                
            </div>
        }

        if (question.type === "multicheckbox") {
          divContainer = (
            <div
              key={"selectfieldTilesDivFirstResult" + current}
              className="row review-box"
            >
              {question.section && this.getSection(question.section)}
              <div className="row col-md-12">
                <div className="col-md-10 review__normal p-0">
                  Question: {this.getHeading(question, patient)}{" "}
                  {this.isRedHeading(question)}{" "}
                  <span> {this.getRedHeading(question)}</span>
                  {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                </div>
                <div className="col-md-2 p-0 text-right">
                  <span
                    onClick={this.goBack.bind(this, "/admin/exam", current)}
                  >
                    <img
                      alt=""
                      src="/imgs/app/edit_icon.svg"
                      title="Edit"
                      style={{ cursor: "pointer" }}
                    />
                  </span>
                </div>
              </div>

              <span className="review__normal">Answer(s):</span>
              {/*iteratisng through each question */}
              {question.questions.map((ques, index) => (
                <ul style={{ marginBottom: "0px" }}>
                  {ques.main && ques.multi && (
                    <span>
                      {ques &&
                        ques.subItems &&
                        ques.subItems.map(
                          (sub, i) =>
                            sub.answer !== "" && (
                              <li>
                                <label className="review__bold">
                                  {sub.answer}
                                </label>
                              </li>
                            )
                        )}
                    </span>
                  )}
                  {ques.main && !ques.multi && (
                    <li>
                      <label className="review__bold">{ques.subAnswer}</label>
                    </li>
                  )}
                </ul>
              ))}
            </div>
          );
        }

        if (question.type === "checkbox") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>
                </div>
                {/* {question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div   className=" mb-20">
                            <label className="review__bold">{ques.main}</label>
                            {
                                ques && ques.subItems && ques.subItems.map((sub, i) => 
                                    <label key={i} className="review__bold" style={{marginLeft: 100, fontSize: 14}}>{sub.main}</label>
                                )
                            }
                        </div>
                        }
                    </div>)
                } */}
                <span className="review__normal">
                            Answer:
                    </span>
                {
                    question.multi ? question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                    {                     
                    <ul><div   className="mb-20">
                        {
                            ques.answer === ques.main && ques.multi &&
                            <span>
                                <li><label className="review__bold">{ques.main}</label></li>
                                <ul>
                                    {ques && ques.subItems && ques.subItems.map((sub, i) => 
                                       sub.answer && <li><label className="review__bold">{sub.main}</label></li>
                                    )}
                                </ul>
                            </span>

                        }

                        {
                            ques.answer === ques.main && !ques.multi &&
                            <span>
                                <li><label className="review__bold">{ques.main}</label></li>
                                {
                                    ques.subAnswer && 
                                    <ul><li><label className="review__bold" >{ques.subAnswer}</label></li></ul>
                                }
                            </span>
                        }
                        
                    </div></ul>
                    }
                    {
                        ques.text1 && <span><label className="review__bold">{ques.text1}</label></span>
                    }
                </div>)                    
                    
                    : question.questions.map((ques, index) =>
                    
                        <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                            {                     
                            <div   className=" mb-20">
                                {
                                    question.answer === ques.main && ques.multi && 
                                    <span><label className="review__bold">{ques.main}</label>
                                    <ul>
                                    {ques && ques.subItems && ques.subItems.map((sub, i) => 
                                        sub.answer && <li><label key={i} className="review__bold" >{sub.main}</label></li>
                                    )}
                                    </ul>
                                    </span>

                                }

                                {
                                    question.answer === ques.main && !ques.multi &&
                                    <span><label className="review__bold">{ques.main}</label>

                                        <label className="review__bold" >{ques.subAnswer && ques.subAnswer}</label>
                                    
                                    </span>

                                }
                                
                            </div>
                            }
                            {
                                ques.text1 && <span><label className="review__bold">{ques.text1}</label></span>
                            }
                        </div>)

                }

                
                
            </div>
        }

        if (question.type === "radioModal") {
            divContainer = <div key={"selectfieldTilesDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" style={{marginTop: '10px'}} >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>
                </div>

                {/* {question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                        {                     
                        <div   className=" mb-20">
                            <label className="review__bold">{ques.main}</label>
                            {ques.text1 && ques.text1.length>0 && <label>{ques.text1}</label>}
                            {ques.text2 && ques.text2.length>0 && <label>{ques.text2}</label>}
                            {
                                ques && ques.subItems && ques.subItems.map((sub, i) => 
                                    <label className="review__bold" style={{marginLeft: 100, fontSize: 14}}>{sub.main}</label>
                                )
                            }
                            {ques.textOther && ques.textOther.length>0 && <label >{ques.textOther}</label>}
                        </div>
                        }
                    </div>)
                } */}
                <span className="review__normal">Answer:</span>
                {
                    question.multi ? visibleQuestionItems.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                    { (ques.answer === ques.main && ques.multi) || (ques.answer === ques.main && !ques.multi) ?                     
                        <ul><div>
                            {
                                ques.answer === ques.main && ques.multi && !question.name &&
                                <span><li><label className="review__bold">{ques.main}</label></li>
                                
                                {
                                    // heart dbq 8A
                                    ques.placeholder1 === "Indicate treatment facility" ? (
                                    <ul>
                                        {
                                            ques.text1 &&
                                            <li>
                                                <label className="review__bold" >Treatment facility: {ques.text1}</label>
                                            </li>
                                        }
                                        {
                                            ques.text2 &&
                                            <li>
                                                <label className="review__bold" >Condition resulted in needing the treatment: {ques.text2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date1 && 
                                            <li>
                                                <label className="review__bold" >Date of treatment: {ques.date1}</label>
                                            </li>
                                        }
                                        {
                                            ques.date2 &&
                                            <li>
                                                <label className="review__bold" >Date of admission: {ques.date2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date3 &&
                                            <li>
                                                <label className="review__bold" >Date of discharge: {ques.date3}</label>
                                            </li>
                                        }
                                    </ul>
                                    ) :
                                    ques && ques.subItems && ques.subItems.map((sub, i) => 
                                        <ul><li><label className="review__bold" >{sub.answer && sub.main}</label></li></ul>
                                    )
                                }
                                </span>

                            }
                            {
                                ques.answer === ques.main && !ques.multi && !question.name &&
                                <span><li><label className="review__bold">{ques.main}</label></li>
                                {
                                    // heart dbq 8A
                                    ques.placeholder1 === "Indicate treatment facility" ? (
                                    <ul>
                                        {
                                            ques.text1 &&
                                            <li>
                                                <label className="review__bold" >Treatment facility: {ques.text1}</label>
                                            </li>
                                        }
                                        {
                                            ques.text2 &&
                                            <li>
                                                <label className="review__bold" >Condition resulted in needing the treatment: {ques.text2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date1 && 
                                            <li>
                                                <label className="review__bold" >Date of treatment: {ques.date1}</label>
                                            </li>
                                        }
                                        {
                                            ques.date2 &&
                                            <li>
                                                <label className="review__bold" >Date of admission: {ques.date2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date3 &&
                                            <li>
                                                <label className="review__bold" >Date of discharge: {ques.date3}</label>
                                            </li>
                                        }
                                    </ul>
                                    ) :
                                    <ul style={{display: ques.subAnswer || ques.text1 ? "block" : "none"}}><li><label className="review__bold" >{ques.subAnswer ? ques.subAnswer : ques.text1 ? ques.text1 : "-"}</label></li></ul>
                                }
                                {ques.subItemOther && ques.textOther && (
                                    <ul><li><label className="review__bold">{ques.textOther}</label></li></ul>
                                )}
                                </span>

                            }
                            {
                                question.name && <span>
                                <li><label className = 'review__bold'>{ques.heading}</label></li>
                                <ul><li><label className="review__bold" >{ques.subAnswer && ques.subAnswer} {ques.subAnswer3 ? '- ' + ques.subAnswer3 : ""}</label></li></ul>
                                </span>
                            }
                            
                        </div></ul> : null
                        }
                    </div>)                    
                    
                    : visibleQuestionItems.map((ques, index) =>
                    
                        <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                            {                     
                            <div>
                                {
                                    question.answer === ques.main && ques.multi && 
                                    <span><li><label className="review__bold">{ques.main}</label></li>
                                    {ques && ques.subItems && ques.subItems.map((sub, i) => 
                                        <ul><li><label className="review__bold" >{sub.answer && sub.main}</label></li></ul>
                                    )}
                                    </span>

                                }

                                {
                                    question.answer === ques.main && !ques.multi &&
                                    <span><li><label className="review__bold">{ques.main}</label></li>
                                                                    {
                                    // heart dbq 9A
                                    ques.placeholder1 === "Indicate treatment facility" ? (
                                    <ul>
                                        {
                                            ques.text1 &&
                                            <li>
                                                <label className="review__bold" >Treatment facility: {ques.text1}</label>
                                            </li>
                                        }
                                        {
                                            ques.text2 &&
                                            <li>
                                                <label className="review__bold" >Condition resulted in needing the treatment: {ques.text2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date1 && 
                                            <li>
                                                <label className="review__bold" >Date of treatment: {ques.date1}</label>
                                            </li>
                                        }
                                        {
                                            ques.date2 &&
                                            <li>
                                                <label className="review__bold" >Date of admission: {ques.date2}</label>
                                            </li>
                                        }
                                        {
                                            ques.date3 &&
                                            <li>
                                                <label className="review__bold" >Date of discharge: {ques.date3}</label>
                                            </li>
                                        }
                                    </ul>
                                    ) :
                                    question.subAnswer && 
                                    <ul><li><label className="review__bold" >{ques.subAnswer}</label></li></ul>
                                }                         
                                </span>

                                }

                                {/* heart dbq 3A */}
                                {
                                   ques.main === "Had Myocardial Infraction (MI)"  && 
                                    <span>
                                        {
                                            ques.date1 &&
                                            <ul><li><label className="review__bold" >Date and treatment facility for MI: {ques.date1} {ques.text1}</label></li></ul>
                                        }
                                        {
                                            ques.date2 &&
                                            <ul><li><label className="review__bold" >Date and treatment facility for MI: {ques.date2} {ques.text2}</label></li></ul>
                                        }
                                        {
                                            ques.textOther && 
                                            <ul><li><label className='review__bold'>Additional MI: {ques.textOther}</label></li></ul>
                                        }
                                    </span>
                                }
                                
                            </div>
                            }
                        </div>)

                }
                {/* {ques && ques.subItems2 && ques.subItems2.length>0 && question.questions.map((ques, index) =>
                    
                    <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                    {ques.subItems2Label && <span><label className="review__bold">{ques.subItems2Label}</label></span>}
                        {                     
                        <div   className=" mb-20">
                            {
                                ques && ques.subItems2 && ques.subItems2.map((sub, i) => 
                                    <label className="review__bold" style={{marginLeft: 100, fontSize: 14}}>{sub.main}</label>
                                )
                            }
                        </div>
                        }
                    </div>)
                } */}
                {visibleQuestionItems.map((ques, index) =>
                    {ques.subItems2 && ques.subItems2.length>0 ? <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                    {ques.subItems2Label && <span><label className="review__bold">{ques.subItems2Label}</label></span>}
                        {                     
                        <div   className=" mb-20">
                            {                                
                                ques.subItems2.map((sub, i) => 
                                    {ques.multi? <label className="review__bold">{sub.main === sub.answer ? sub.main :""}</label>: <label className="review__bold">{sub.main === ques.subAnswer2 ? sub.main :""}</label>}
                                    
                                )
                            }
                        </div>
                        }
                    </div> : null})
                } 
                {visibleQuestionItems.map((ques, index) =>
                    {ques.subItems3 && ques.subItems3.length>0 ? <div className="row col-md-12" key={"selectfieldDivResult"+index}> 
                    {ques.subItems3Label && <span><label className="review__bold">{ques.subItems3Label}</label></span>}
                        {                     
                        <div   className=" mb-20">
                            {                                
                                ques.subItems3.map((sub, i) => 
                                    {ques.multi? <label className="review__bold">{sub.main === sub.answer ? sub.main :""}</label>: <label className="review__bold">{sub.main === ques.subAnswer3 ? sub.main :""}</label>}
                                    
                                )
                            }
                        </div>
                        }
                    </div> : null})
                }                
                
            </div>
        }

        if (question.type === "textarea") {
            const textareaAnswer = getDiagnosisRemarksCombinedAnswer(question);
            divContainer = <div key={"textareafieldDivFirstResult"+current} className="row review-box">
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12" >
                    <div className="col-md-10 review__normal p-0" >Question: {this.getHeading(question, patient)} {this.isRedHeading(question)} <span > {this.getRedHeading(question)}</span>
                    {/* <div className="col-md-12 review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                    </div>
                    <div className="col-md-2 p-0 text-right">
                            {/* <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="btn-custome-blue"
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >Edit</Button> */}
                            <span
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >
                                <img alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
                            </span>
                    </div>                    
                </div>
                <span className="review__normal">Answer:</span>
                { textareaAnswer ?
                    <div  key={"textareafieldDivResult"+current} className="row col-md-12 ">
                        {
                            question.additionalResponse && question.additionalResponse.length >= 1 ? (
                                <label className="review__bold" style={{wordBreak: "break-word"}}>

                                <span style={{ fontWeight: "normal" }}>
                                    Veteran comment:{" "}
                                </span>
                                {textareaAnswer}
                                </label>

                            ) : (
                                <label className="review__bold" style={{wordBreak: "break-word"}}>
                                {textareaAnswer}
                                </label>
                            )
                        }
                    </div>
                    :
                    <label className="review__bold">
                    -
                    </label>
                }
                {question.additionalResponse && question.additionalResponse.length >= 1 && (
                    <label className="review__bold" style={{wordBreak: "break-word"}}>
                        <span style={{ fontWeight: "normal" }}>
                        Provider comment:
                        </span>{" "}
                        {question.additionalResponse}
                    </label>
                )}
                
            </div>
        }

        if (question.type === "yesno" || question.type === "yesnoouter") {
            divContainer = (
              <div
                key={"textareafieldDivFirstResult" + current}
                className="row review-box"
              >
                {question.section && this.getSection(question.section)}
                <div className="row col-md-12">
                  <div className="col-md-10 review__normal p-0">
                    Question: {this.getHeading(question, patient)}
                    {this.isRedHeading(question)}
                    <span>{this.getRedHeading(question)}</span>
                    {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div>                        */}
                  </div>
                  <div className="col-md-2 p-0 text-right">
                    {/* <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="btn-custome-blue "
                                onClick={this.goBack.bind(this, "/admin/exam", current)}
                            >Edit</Button> */}
                    <span
                      onClick={this.goBack.bind(this, "/admin/exam", current)}
                    >
                      <img
                        alt=""
                        src="/imgs/app/edit_icon.svg"
                        title="Edit"
                        style={{ cursor: "pointer" }}
                      />
                    </span>
                  </div>
                  {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
                </div>
                {question.answer && (
                  <div
                    key={"textareafieldDivResult" + current}
                    className="row col-md-12 mb-20 "
                  >
                    <label className="review__bold" style={{wordBreak: "break-word"}}>{question.answer}</label>
                  </div>
                )}
                {question.textanswer && (
                  <div
                    key={"textareatextanswer" + current}
                    className="row col-md-12 mb-20 "
                  >
                    <label className="review__bold" style={{wordBreak: "break-word"}}>{question.textanswer}</label>
                  </div>
                )}
                {(question.hasAdditionalResponse && question.additionalResponse !== undefined && question.additionalResponse.length !== 0 )|| (question.istext && question.textarea) ? (
                  <div
                    key={"textareafieldtextDivResult" + current}
                    className="row col-md-12 mb-20 "
                  >
                    {
                        question.isOverwritten === false &&
                            <label className="review__bold" style={{wordBreak: "break-word"}}>
                                {
                                    question.hasAdditionalResponse &&
                                    question.additionalResponse !== undefined && question.additionalResponse.length !== 0 ? <span style={{ fontWeight: "normal" }}>Veteran comment: </span> : null
                                }
                            {question.textanswer}
                            </label>
                    }
                    {question.hasAdditionalResponse &&
                            question.additionalResponse !== undefined && question.additionalResponse.length !== 0  ? (
                      
                        question.isOverwritten === false ? 
                            <label className="review__bold">
                            <span style={{ fontWeight: "normal" }}>
                            Provider comment:
                            </span>
                            {question.additionalResponse}
                        </label> :
                        <label className="review__bold" style={{wordBreak: "break-word"}}>
                            <span style={{ fontWeight: "normal" }}>Answer: {question.additionalResponse}</span>
                        </label>
                      
                    ) : null}
                  </div>
                ): null }
              </div>
            );
        }

        // if (question.type === "yesnoouter") {
        //     divContainer = <div key={"textareafieldDivFirstResult"+current} className="row review-box">
        //         {question.section && this.getSection(question.section)}
        //         <div className="row col-md-12" >
        //             <div className="col-md-10 review-heading p-0" >
        //                 {this.getHeading(question, patient)}
        //                 {this.isRedHeading(question)} 
        //                 <span > 
        //                     {this.getRedHeading(question)}
        //                 </span> 
        //                 <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div>                       
        //             </div>
        //             <div className="col-md-2 p-0 text-right">
        //                     <span
        //                         onClick={this.goBack.bind(this, "/admin/exam", current)}
        //                     >
        //                         <img  alt="" src="/imgs/app/edit_icon.svg" title="Edit" style={{cursor: 'pointer'}}  />
        //                     </span>
        //             </div>
        //             {/* <div className="review-sub-heading" >{question.sub ? question.sub.replace("##name##", patient && patient.name) : ''}</div> */}
        //         </div>
        //         { question.answer &&
        //             <div  key={"textareafieldDivResult"+current} className="row col-md-12 mb-20 " >
        //                <label className="review__bold">{question.answer}</label>
        //             </div>
        //         }
                
        //     </div>
        // }

        return divContainer;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
        console.log("EXAM state current dbq", this.state.currentDbq)
        console.log("EXAM state patient", this.state.patient)
        console.log("EXAM state questions", this.state.questions)
    }

    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'br',
            autoDismiss: 2
        })

        if (type === 'error') {
            this.setState({
                emailError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                },
                passwordError: {
                    status: FIELD_STATUSES.ERROR,
                    message: ''
                }
            })
        }
    }

    getRedHeading = (question) => {
        if (question && question.redHeading && !question.question.includes("##redHeading##")) 
        {
            return question.redHeading;
        } else {
            return ''
        }        
    }

    isRedHeading  = (question) => {
        if (question && question.redHeading && !question.question.includes("##redHeading##")) 
        {
            return '-';
        } else {
            return ''
        }
    }

    getHeading  = (question, patient) => {
        let qheading =  question.question.replace("##name##", patient && patient.name);
        if (question && question.redHeading && question.question.includes("##redHeading##")) 
        {
            qheading = qheading.split('##redHeading##')
            return <span> {qheading[0]} <span >{question.redHeading}</span>{qheading[1]}</span>
        } else {
            return <span>{qheading}</span>
        }
    }


    render() {
        const { patient = undefined, questions } = this.state;
       // const updatedQuestions = questions;
        // if(questions){
        //     for(let i =0; i < questions.length; i++){
        //         updatedQuestions.push(questions[i])
        //         if(questions[i].type === "yesno" && questions[i].answer !== questions[i].presidence){
        //             i = i + questions[i].ref;
        //         }
        //     } 
        // }
        const { fetching, error} = this.props
        return (
            <div /*className="show-with-ease"*/ id="MyComponent">
                <Row className="">
                    <Col mdOffset={1} md={10} className="text-center">
                        {/* <div className='heading-card'> */}
                            <h1 className="heading-main">
                                <strong>Review Responses</strong>
                            </h1>
                        {/* </div> */}
                        <div style={{textAlign: 'end'}}>
                            {/* <span style={{cursor: 'pointer', fontSize: '16px', color: '#079EDA'}} onClick={this.getPdf}>Download</span> */}
                        <Button
                                lg
                                type='button'
                                bsStyle='primary'
                                className="next-btn big-btn float-right"
                                onClick={this.actions.bind(this, "/admin/dbq")}
                                >Skip<span className="nexticonspan"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="white"/>
                                </svg>
                                </span>
                            </Button>
                        </div>
                        <div id="review-page" style={{marginTop:30}}>

                            {questions && questions.map((question, index)=> 
                                question.show && this.getElement(question, index, patient) 
                            )}
                        </div>
                    </Col>
                </Row>
                {fetching && !error && <LoadingDocument/>}
                <NotificationSystem ref='notificationSystem'/>
                
                <Row className="button-bottom" style={{ bottom: 0, marginBottom: 15, marginTop: 15 }}>
                    <Col xs={6} collapseLeft collapseRight className='text-right button-bottom'>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="back-btn big-btn accept-btn-width"
                            onClick={this.goBack.bind(this, "/admin/exam", 0)}
                        >Back<span className="backiconspan"><svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z" fill="#797979"/>
                        </svg>
                        </span></Button>
                    </Col>
                    <Col xs={6} collapseLeft collapseRight
                        className='text-left button-bottom'>
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="next-btn big-btn accept-btn-width"
                            onClick={this.actions.bind(this, "/admin/dbq")}
                        >Accept<span className="nexticonspan"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z" fill="white"/>
                        </svg>
                        </span></Button>
                    </Col>
                </Row>

            </div>
        )
    }
}


const mapStateToProps = state => ({
    patient: {
        specific: {
            patientInfo, fetching, error, isPatientUpdate
        }
    },
  }) => {
   return {
    patientInfo,
    fetching,
    error,
    isPatientUpdate
   }
}

const mapDispatchToProps = dispatch => ({
    updatePatientDoc: (id, apptDate, dbq, questions, ssn, status, patientName, dbqId, isPreviousVersion, apptId, selectedLicense, diagnosesAndExtremities, doctorLocalDate) => {
        dispatch(PatientActions.updateSpecificPatientRequest({
            id,
            apptDate,
            dbq,
            questions,
            ssn,
            status,
            patientName,
            dbqId,
            isPreviousVersion,
            apptId,
            selectedLicense: selectedLicense,
            diagnosesAndExtremities: diagnosesAndExtremities,
            doctorLocalDate
        }))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Review)
